export interface IFederatedLoginResponse {
  clientId: string;
  realm: string;
  baseUrl: string;
  host: string;
  port: number;
  scheme: string;
  path: string;
  redirectUri: string;
  nonce: string;
  state: string;
  responseType: string;
  responseMode: string;
  scope: string;
  kcIdpHint: string;
  loginHint: string;
  prompt: string;
  redirectUrl: string;
}

export enum LoginMethod {
  DEFAULT = 'DEFAULT',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
}

export enum IFederatedLoginEnvironmentVariables {
  NONCE = 'nonce',
  STATE = 'state',
  REALM = 'realm',
  CLIENT_ID = 'clientId',
  BASE_URL_AUTH = 'baseUrlAuth',
  AUTHORIZE_ENDPOINT = 'authorizeEndpoint',
  TOKEN_ENDPOINT = 'tokenEndpoint',
  COOKIE_DOMAINS = 'cookieDomains',
}
